const USER_ROLES = {
  ADMIN: '',
  DIRECTOR: 'DIRECTOR',
  MANAGER: 'MANAGER'
};

const USER_ROLE_OPTIONS = [
  { label: 'Director', value: 'DIRECTOR' },
  { label: 'Manager', value: 'MANAGER' }
];

export { USER_ROLES, USER_ROLE_OPTIONS };
